<onboarding-container [loading]="facade.loggingIn$ | async" [hideLogout]="true" [hideForward]="true" [hideBack]="true">
  <div class="zero-text p-huge-med">
    {{ 'onboarding.login-after-email-confirmation.headline' | transloco }}
  </div>
  @if (facade.sentConfirmationDataError$ | async; as error) {
    <div class="mt-2 zero-text p-small-reg course-red">
      {{ 'onboarding.login-after-email-confirmation.confirm-error' | transloco }}
      <a [routerLink]="resendConfirmationLink" class="zero-text link text-nowrap">{{
        'onboarding.login-after-email-confirmation.confirm-error-link' | transloco
      }}</a>
    </div>
  } @else if (isConfirmed) {
    <div
      class="mt-2 zero-text p-small-reg course-green"
      [innerHTML]="'onboarding.login-after-email-confirmation.confirmed-hint' | transloco"
    ></div>
  }
  <web-design-system-input
    class="d-block mt-4"
    type="text"
    [value]="email$ | async"
    (valueChange)="handleEmailChange($event)"
    [isValid]="email$ | async | email"
    [error]="(email$ | async | email) === false ? ('login.default.error.frontendValidationUsername' | transloco) : null"
    [label]="'onboarding.login-after-email-confirmation.email' | transloco"
    [autocomplete]="autocomplete"
  />
  <web-design-system-input
    class="d-block mt-3"
    type="password"
    [value]="password$ | async"
    (valueChange)="handlePasswordChange($event)"
    [isValid]="password$ | async | password"
    [error]="(password$ | async | password) === false ? ('register.sign-up.password.error' | transloco) : null"
    [label]="'onboarding.login-after-email-confirmation.password' | transloco"
    data-zid="password"
  />
  <div class="mt-5">
    @if (facade.loginErrorMessage$ | async; as errorMessage) {
      <div class="zero-text p-base-reg course-red mb-3">{{ errorMessage }}</div>
    }
    <div class="d-block d-md-flex justify-content-between align-items-center">
      <a class="zero-text link" [routerLink]="passwordForgetLink">
        {{ 'onboarding.login-after-email-confirmation.forgot-password' | transloco }}
      </a>
      <web-design-system-button
        data-zid="login-btn"
        (click)="submit()"
        [disabled]="(isFormValid$ | async) === false"
        [fullwidth]="true"
        class="d-block mt-3 mt-md-0"
      >
        {{ 'onboarding.login-after-email-confirmation.btn' | transloco }}
      </web-design-system-button>
    </div>
  </div>
  <div class="mt-5">
    <web-design-system-notification
      color="blue"
      [headline]="'onboarding.login-after-email-confirmation.iban-notification.headline' | transloco"
      [isDismissible]="false"
    >
      <div [innerHTML]="'onboarding.login-after-email-confirmation.iban-notification.text' | transloco"></div>
    </web-design-system-notification>
  </div>
</onboarding-container>
